import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type CashFundIconProps = CreateIconComponentProps;
export const CashFundIcon: React.FC<CashFundIconProps> = ({
  title = 'CashFund',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <rect
      width="15"
      height="11"
      x="7"
      y="9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx="2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.233"
      d="M15.912 13.25a.88.88 0 0 0-.793-.44h-.88a.88.88 0 0 0 0 1.761h.88a.88.88 0 0 1 0 1.762h-.88a.881.881 0 0 1-.794-.44"
    />
    <path
      fill="currentColor"
      d="M15.172 11.929a.493.493 0 1 0-.987 0h.987Zm-.987.88a.493.493 0 0 0 .987 0h-.987Zm.987 3.525a.493.493 0 1 0-.987 0h.987Zm-.987.88a.493.493 0 1 0 .987 0h-.987Zm0-5.285v.88h.987v-.88h-.987Zm0 4.405v.88h.987v-.88h-.987Z"
    />
  </CreateIconComponent>
);
